export const MAX_SFÆRE = 10.25
export const MAX_SYLINDER = 6.25

export const MAX_ADD = 3

export const MIN_STYRKE = 0
export const MAX_STYRKE = 99.99
